import { render } from "./ShopBasket.vue?vue&type=template&id=0e6258d6"
import script from "./ShopBasket.vue?vue&type=script&lang=js"
export * from "./ShopBasket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__